import React, { useRef, useState, useCallback } from 'react'
// import './style.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../CtaButton';

const IndustryDetailCard = ({ HireUsData, content, heading }) => {

    const sliderRef = useRef();

    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const { t } = useTranslation("industries");
    const staticHeading = t("staticHeading", { returnObjects: true });

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const handleSlideChange = (swiper) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };

    return (
        <>
            <div className="hire-us-box industry-detail-solutions-cards">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <h4 className="text-white text-left main-heading">{heading}</h4>
                            <p className="text-white text-left common-text">{content}</p>
                        </div>

                        <div className="col-md-4 d-flex align-items-end flex-column">
                            <Button text={staticHeading?.bookAnAppointment} newTab link='https://calendly.com/bitsclan-it/30min?' />

                            {HireUsData?.length > 3 ? <div className="col-md-12 mt-4">
                                <div className="arrow-developing-slider">
                                    <img
                                        onClick={handlePrev}
                                        src="/images/arrow-right.png"
                                        className={`left-image ${isBeginning ? 'disabled' : ''}`}
                                        alt="Arrow"
                                        style={{ cursor: isBeginning ? 'not-allowed' : 'pointer' }}
                                    />
                                    <img
                                        onClick={handleNext}
                                        src="/images/arrow-right.png"
                                        className={`${isEnd ? 'disabled' : ''}`}
                                        alt="Arrow"
                                        style={{ cursor: isEnd ? 'not-allowed' : 'pointer' }}
                                    />
                                </div>
                            </div> : ""}
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12 hire-us-swiper home-card-box">
                            <Swiper
                                slidesPerView={'3'}
                                spaceBetween={20}
                                navigation={false}
                                onSlideChange={handleSlideChange}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                }}
                                modules={[Navigation, Autoplay]}
                                className="mySwiper"
                                ref={sliderRef}
                                breakpoints={{
                                    425: {
                                        slidesPerView: 1,
                                        spaceBetween: 10,
                                    },
                                    375: {
                                        slidesPerView: 1,
                                        spaceBetween: 10,
                                    },
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 10,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                        spaceBetween: 10,
                                    },
                                    1280: {
                                        slidesPerView: 3,
                                        spaceBetween: 10,
                                    },
                                }}
                            >
                                {HireUsData?.map(slide => (
                                    <SwiperSlide key={slide.id}>
                                        <div className={`hire-us-card ${slide.borderClass}`}>
                                            {/* <div className="hire-us-icon">
                                                <img src={slide.icon} alt={slide.heading} />
                                            </div> */}
                                            <h4 className="common-heading">{slide.title}</h4>
                                            <p className="common-text">{slide.description}</p>
                                            {/* {
                                                slide.btnLink === "commingsoon" ? <a data-bs-toggle="modal" href="#comingsoon-model" role="button">
                                                    I’m looking for <i className="fa-solid fa-arrow-right-long"></i>
                                                </a> : <Link to={`/${slide?.btnLink}`}>
                                                    I’m looking for <i className="fa-solid fa-arrow-right-long"></i>
                                                </Link>
                                            } */}
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className="col-md-12">
                            <div className="w-100 d-flex flex-row justify-content-center mt-5">
                                <div className="hire-us-cta-btn">
                                    <a role="button" href="https://calendly.com/bitsclansolutions/15min" target="_blank" className="ms-0 px-4">{staticHeading?.bookAnAppointment}</a>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div >
            </div >
        </>
    )
}

export default IndustryDetailCard